import { DatePipe } from '@angular/common'
import { Extrato } from '../../../../pkw-data/collect/extrato/extrato.interface'
import { Transacao } from '../../../../pkw-data/collect/extrato/transacao.model'
import { OperadoraDeMaquina } from '../../../../pkw-data/collect/operadora-de-maquina.model'
import { CORES_OPERADORAS } from '../../shared/cores-operadoras.const'

export abstract class ChartUltimos10DiasOptions {
    protected static datePipe = new DatePipe('pt')

    title: { text: string }
    extrato: Extrato<Transacao>
    colors: string[]
    series: { name: string; data: number[] }[]

    chart = {
        type: 'column'
    }
    xAxis = {
        categories: [],
        labels: {
            rotation: -45
        }
    }
    yAxis = {
        labels: {
            format: 'R$ {value}'
        },
        title: {
            text: ''
        }
    }
    credits = {
        enabled: false
    }
    plotOptions = {
        column: {
            stacking: 'normal'
        }
    }
    tooltip = {
        shared: true,
        borderColor: '#66afe9',
        valuePrefix: 'R$ ',
        valueDecimals: 2
    }

    protected operadoras: OperadoraDeMaquina[]
    protected datas: Date[]

    constructor(extrato: Extrato<Transacao>, titulo: string) {
        this.extrato = extrato
        this.title = { text: titulo }
        this.operadoras = extrato
            ? extrato.agrupamentos.map(agrupamento => agrupamento.operadora)
            : []
        this.colors = this.operadoras.map(operadora => CORES_OPERADORAS[operadora.id])
        this.datas = this.obterDatas()
        this.xAxis.categories = this.obterCategorias()
        this.series = this.obterSeries()
    }

    abstract obterSeries(): { name: string; data: number[] }[]

    private obterDatas(): Date[] {
        const datas = []
        const hoje = new Date()
        const ultimoDia = hoje.getDate() - 1
        const primeiroDia = ultimoDia - 9

        for (let dia = primeiroDia; dia <= ultimoDia; dia++) {
            datas.push(new Date(hoje.getFullYear(), hoje.getMonth(), dia))
        }

        return datas
    }

    private obterCategorias(): string[] {
        return this.datas.map(data =>
            ChartUltimos10DiasOptions.datePipe.transform(data, 'dd/MM/yyyy')
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/dashboard-extratos/ultimos-10-dias/shared/chart-ultimos-10-dias-options.ts